import { render, staticRenderFns } from "./FlowingWater.vue?vue&type=template&id=03cb5828&scoped=true&"
import script from "./FlowingWater.vue?vue&type=script&lang=js&"
export * from "./FlowingWater.vue?vue&type=script&lang=js&"
import style0 from "./FlowingWater.vue?vue&type=style&index=0&id=03cb5828&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cb5828",
  null
  
)

export default component.exports